import { Grid, Typography, useTheme } from "@mui/material";
import React from "react";
import ProfileDataCard from "./ProfileDataCard";

interface AddressProps {
  homeAddressStreet: string;
  homeAddressNumber: string;
  homeAddressCity: string;
  homeAddressPostalCode: string;
  studyAddressStreet: string;
  studyAddressNumber: string;
  studyAddressCity: string;
  studyAddressPostalCode: string;
}

/**
 * This component displays the address of an applicant
 * @param homeAddressStreet The street of the home address
 * @param homeAddressNumber The number of the home address
 * @param homeAddressCity The city of the home address
 * @param homeAddressPostalCode The postal code of the home address
 * @param studyAddressStreet The street of the study address
 * @param studyAddressNumber The number of the study address
 * @param studyAddressCity The city of the study address
 * @param studyAddressPostalCode The postal code of the study address
 * @returns The Address component
 */
const Address = ({
  homeAddressStreet,
  homeAddressNumber,
  homeAddressCity,
  homeAddressPostalCode,
  studyAddressStreet,
  studyAddressNumber,
  studyAddressCity,
  studyAddressPostalCode,
}: AddressProps) => {
  const theme = useTheme();

  return (
    <ProfileDataCard title="Adresse">
      <Grid container sx={{ paddingLeft: 1, paddingRight: 1 }} rowSpacing={1}>
        <Grid item xs={12} sm={6}>
          <Typography fontWeight={"bold"} color={theme.palette.info.main}>
            Heimatanschrift
          </Typography>
          <Typography>
            {homeAddressStreet} {homeAddressNumber}
          </Typography>
          <Typography>
            {homeAddressPostalCode} {homeAddressCity}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography fontWeight={"bold"} color={theme.palette.info.main}>
            Studienanschrift
          </Typography>
          <Typography>
            {studyAddressStreet} {studyAddressNumber}
          </Typography>
          <Typography>
            {studyAddressPostalCode} {studyAddressCity}
          </Typography>
        </Grid>
      </Grid>
    </ProfileDataCard>
  );
};

export default Address;
